import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
     * Konstante mit allen Namen der möglichen Cookies.
     */
const apiLinks = {
    flyout: "api/status/comp",
    list: "api/status/comp/list",
    dialog: "api/status/comp/dialog"
};

export function getStatusById(id: number): JQueryPromise<modelsGet.IStatus>
{
    var endpoint = new URI("api/status");
    endpoint.segment(id.toString());

    return api.get<modelsGet.IStatus>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Statuseinträge zurück.
 */
export function getStatus(usergroupId?: number, onEdit?: boolean, statusIds?: number[]): JQueryPromise<modelsGet.IStatus[]>
{
    return api.get<modelsGet.IStatus[]>({
        endpoint: "api/status",
        data: {
            usergroupId: usergroupId,
            onEdit: onEdit,
            ids: (statusIds || []).join(",")
        }
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(status: modelsPost.IStatus): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/status/create",
        data: JSON.stringify(status)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, status: modelsPost.IStatus): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/status/edit/${id}`,
        data: JSON.stringify(status)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/status/delete/${id}`
    });
}